import React, { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const WOSplit = () => {
    const workOrderSchema = z.object({
        target_quantity: z.number(),
        prod_start_date: z.date(),
        dispatch_date: z.date(),
    });
    const formSchema = z.object({
        work_orders: z.array(workOrderSchema),
    });
    const { control, handleSubmit, register } = useForm({
        resolver: zodResolver(formSchema),
    });
    const { fields, append } = useFieldArray({
        control,
        name: "work_orders",
    });
    const onSubmit = (data) => {
        console.log(data);
    };
    useEffect(() => {
        append({
            target_quantity: 1000,
            dispatch_date: new Date("30-04-2025"),
            prod_start_date: new Date("5-05-2025"),
        });
    }, []);
    return (
        <div className="card">
            <div className="card-inner">
                <form onSubmit={handleSubmit(onSubmit)}>
                    {fields.map((field, index) => (
                        <div className="card my-2" key={index}>
                            <div className="card-inner">
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <label className="form-label">
                                        Target Quantity
                                    </label>
                                    <input
                                        className="form-control"
                                        type="number"
                                        step={"any"}
                                        {...register(
                                            `work_orders.${index}.target_quantity`
                                        )}
                                    />
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <label className="form-label">
                                        Production Start Date
                                    </label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        {...register(
                                            `work_orders.${index}.prod_start_date`
                                        )}
                                    />
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <label className="form-label">
                                        Dispatch Date
                                    </label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        {...register(
                                            `work_orders.${index}.dispatch_date`
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </form>
            </div>
        </div>
    );
};

export default WOSplit;
